import ApiClient from "../ApiClient";

const AccountService = {

  async createAccount(payload) {
    const resp = await ApiClient.post(`/Account/create-account`, payload);
    return resp;
  },

  async checkDomain(payload) {
    const domainName = payload?.domainName;
    const resp = await ApiClient.post("/Account/check-domain", payload, {
      params: { DomainName: domainName },
    });
    return resp;
  },

  async migrateDatabase(payload) {
    const dbname =  payload?.dbname ;
    const resp = await ApiClient.post("/Account/migarte-database", payload, {
      params: { dbname },
    });
    return resp;
  },

};

export default AccountService;
